export default {
  currentUser: state => state.currentUser,
  isLoggedIn: state => state.currentUser != null,
  userToken: state => state.userToken,
  presetCouponCode: state => state.presetCouponCode,
  inviteCodes: state => state.inviteCodes,
  hasMembershipAccess: state => state.hasMembershipAccess,
  selectedMembershipType: state => state.selectedMembershipType,
  // Payment
  squareStatus: state => state.squareStatus,
  stripeStatus: state => state.stripeStatus,

  // Utility Properties
  message: state => state.message,
  isLoading: state => state.isLoading,
  isError: state => state.isError,
  lastError: state => state.lastError,
  ticketsUri: state => state.ticketsUri,
  membershipCoupon: state => state.membershipCoupon,
  hideUpgradeWallUntil: state => state.hideUpgradeWallUntil,
  hideActionRequired: state => state.hideActionRequired,
  membershipScanPending: state => state.membershipScanPending,
}